import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { AttachedPropertyValue } from "../../../uiPatterns/component";

export class ComponentAttachedPropertyHtmlBridgePrototype extends HtmlBridgePrototype{

    public propertyName:string;
    
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ComponentAttachedPropertyHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class ComponentAttachedPropertyHtmlBridge extends HtmlBridge{
    
    private propertyName:string;
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    private componentViewModel : ViewModel;
    constructor(prototype:ComponentAttachedPropertyHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.propertyName = prototype.propertyName;
    }
    
    public set value(v: any) { 
        this._value = v; 
        let changedValue = new AttachedPropertyValue(this.element,this.value);
        this.componentViewModel[this.propertyName]=changedValue;
    } public get value(): any { return this._value;} private _value: any;

    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.componentViewModel = (<any>node.parentNode).binderRelatedView.dataContext;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }

    public release(){
        this.binding.release();
    }
}